import request, { authOptions } from 'api/requestUtils'
import type { definitions } from '@luxuryescapes/contract-svc-agent'

type LinkSocieteRequest = definitions['linkSocieteRequest']
type LinkSocieteResponse = {
  confirmationRequired?: boolean
}

export interface LinkSocieteParams {
  email?: string
  societeNumber?: string
}

async function requestPostLinkSociete(params: LinkSocieteParams) {
  const requestBody: LinkSocieteRequest = {
    email: params.email,
    societeNumber: params.societeNumber,
  }

  const response = await request.post<App.ApiResponse<LinkSocieteResponse>, LinkSocieteRequest>(
    '/api/agent/user/societe/link',
    requestBody,
    authOptions(),
  )

  return response.result
}

export default requestPostLinkSociete
